<template>
  <el-button
    :type="elementType"
    :size="elementSize"
    :style="buttonStyle"
    :class="hoverClass"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot />
  </el-button>
</template>

<script>
export default {
  name: "AppButton",
  props: {
    variant: {
      type: String,
      default: "default",
    },
    size: {
      type: String,
      default: "default",
    },
    width: {
      type: String,
      default: false,
    },
    alignText: {
      type: String,
      default: "center",
    },
    fontSize: {
      type: String,
      default: "16px",
    },
    color: {
      type: String,
      default: "#fff"
    },
    colorHover: {
      type: String,
      default: "#fff"
    },
  },
  computed: {
    elementType() {
      const map = {
        default: "default",
        primary: "primary",
        danger: "danger",
        info: "info",
        success: "success",
        link: "text",
        borderless: "borderless",
      }
      return map[this.variant] || "default"
    },
    elementSize() {
      const map = {
        default: "medium",
        small: "small",
        large: "large",
        medium: "medium",
        borderless: "medium",
      }
      return map[this.size] || "medium"
    },
    buttonStyle() {
      const styles = {}
      
      if (this.width) {
        styles.width = this.width
      }
      
      if (this.fontSize) {
        styles.fontSize = this.fontSize
      }

      if (this.color) {
        styles.color = this.color
      }

      if (this.alignText) {
        styles.textAlign = this.alignText
        styles.justifyContent = {
          left: 'flex-start',
          center: 'center', 
          right: 'flex-end'
        }[this.alignText] || 'center'
      }

      return styles
    },
    hoverClass() {
      return `hover-color-${this._uid}`
    },
  },
  watch: {
    colorHover: {
      immediate: true,
      handler(newVal) {
        const styleId = `hover-style-${this._uid}`
        let styleEl = document.getElementById(styleId)
        
        if (!styleEl) {
          styleEl = document.createElement('style')
          styleEl.id = styleId
          document.head.appendChild(styleEl)
        }
        
        styleEl.innerHTML = `
          .hover-color-${this._uid}:hover {
            color: ${newVal} !important;
          }
        `
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.el-button {
  font-family: "Ubuntu Mono", monospace;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;

  & + .el-button {
    margin-left: 15px;
  }

  &--default {
    border-color: $corBranco;
    background-color: $corPreto;
    //color: $corBranco;
    
    &:hover{
      border-color: $corBranco;
      background-color: $corPreto;
      color: $corBranco;
    }
  }
  &--primary{
    border-color: $corPrimary;

    &:hover{
      border-width: 2px;
      border-color: $corPrimary;
      background-color: $corBranco;
      color: $corPreto;
    }
  }
  &--large{
    font-size: 16px;
    padding: 8px 32px;
    font-weight: 600;
    height: 44px;
  }
  &--borderless {
    border: none;
    box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.25);
    background: $backgroundButton;
    height: 40px;
    font-weight: 500;
    //color: $corBranco;
    font-size: 16px;

    &:hover {
      box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.25);
      background: $backgroundButton !important;
      color: $corBranco;
    }
  }


  &:focus {
    background: transparent;
  }
}

</style>

<style lang="scss">
button{
  span{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    img{
      margin-top: 4px;
      line-height: 0;
      
      &.img-left {
        margin-right: 6px;
      }
      &.img-right {
        margin-left: 6px;
      }
    }

  }
  &.positionTextLeft{
    span{
      justify-content: flex-start;
    }
  }
  &.positionTextRight{
    span{
      justify-content: flex-end;
    }
  }
}
</style>
